// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_WUzfF","textarea":"index_textarea_C79Jq","btnWrap":"index_btnWrap_3HUmL","btnSubmit":"index_btnSubmit_5MNbB"};